import { render, staticRenderFns } from "./DashboardMain.vue?vue&type=template&id=69884133&scoped=true"
import script from "./DashboardMain.vue?vue&type=script&lang=js"
export * from "./DashboardMain.vue?vue&type=script&lang=js"
import style0 from "./DashboardMain.vue?vue&type=style&index=0&id=69884133&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69884133",
  null
  
)

export default component.exports